const ALLOWED_EXTENSIONS = new Set(['jpg', 'jpeg', 'png']);
const MAX_PHOTO_BYTES = 5 * 1024 * 1024;

export function deriveWizardPhotoFileName(file) {
  if (!file) return 'photo.jpg';
  const raw = typeof file.name === 'string' ? file.name.trim() : '';
  const ext = raw.split('.').pop()?.toLowerCase();
  if (ext && ALLOWED_EXTENSIONS.has(ext)) {
    return raw;
  }
  const mime = file.type?.toLowerCase() || '';
  if (mime === 'image/png') return 'photo.png';
  if (mime === 'image/jpeg' || mime === 'image/jpg') return 'photo.jpg';
  return 'photo.jpg';
}

export function isAllowedWizardPhotoFile(file) {
  if (!file) return false;
  if (file.size > MAX_PHOTO_BYTES) return false;
  const ext = deriveWizardPhotoFileName(file).split('.').pop()?.toLowerCase();
  return Boolean(ext && ALLOWED_EXTENSIONS.has(ext));
}
